import React, { useState } from 'react';

const DownloadSensorPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showDownloadSensorPopup,setShowDownloadSensorPopup] = useState<boolean>(false);

    const downloadSensorToggleHandler = () => {
        setShowDownloadSensorPopup(!showDownloadSensorPopup);
    }
	
	return <Component showDownloadSensorPopup={showDownloadSensorPopup} downloadSensorToggleHandler={downloadSensorToggleHandler} {...props}/>;
};

export default DownloadSensorPopupHOC;   